import React, { useEffect } from "react";
import About from "../components/About";
import CarouselBanner from "../components/CarouselBanner";
import Services from "../components/Services";

function HomePage() {
  return (
    <div className="container-fluid g-0 bg-dark">
      <CarouselBanner />
      <Services />
      <About />
    </div>
  );
}
export default HomePage;
